// Slip checkboxes that mirror onto a client's shared "T Slips" task.
// compilation is intentionally excluded — it's a corporate engagement type.
export const SLIP_FIELDS = ["t4_slips", "t5_slips", "t1135"];

export const SLIP_LABELS = {
  t4_slips: "T4",
  t5_slips: "T5",
  t1135: "T1135",
};

// Decide what unchecking `field` on a Corporate/Personal task should do to the
// client's shared T Slips task. Pure — reads only the tasks already in state.
//   null              -> no open T Slips task carries this flag; nothing to do
//   { action:'clear' } -> clear the flag on the T Slips task
//   { action:'delete'} -> the flag is the last slip and no time is logged; offer
//                         to delete the T Slips task instead
export function planTslipUncheck(tasks, { clientId, fiscalYear, field }) {
  const tslip = (tasks || []).find(
    (t) =>
      t.client === clientId &&
      t.task_category === "tslips" &&
      t.fiscal_year === fiscalYear &&
      !t.is_completed &&
      t[field] === true
  );
  if (!tslip) return null;

  const remaining = SLIP_FIELDS.filter((f) => f !== field && tslip[f] === true);
  if (remaining.length === 0 && (tslip.time_entry_count || 0) === 0) {
    return { tslipTaskId: tslip.id, action: "delete" };
  }
  return { tslipTaskId: tslip.id, action: "clear" };
}
